import { CHART_COLORS, seriesColumnConfig } from './chartStyle';

/**
 * Configuration function for internal expenses chart.
 * @param {Array} data - Data for the internal expenses chart.
 * @returns {Object} - Configuration object for the internal expenses chart.
 */
export const internExpencesConfig = (data) => ({
  ...seriesColumnConfig({
    domain: ['N-1', 'N'],
    colors: [CHART_COLORS.mutedLight, CHART_COLORS.muted]
  }),
  data,
  xField: 'month',
  yField: 'sales',
  tooltip: {
    items: [(item) => ({ name: item.type, value: `${item.sales} €` })]
  }
});
